<style lang="less" scoped>
.home-container {
  padding: 24px 0;
  background-color: #fcfbfb;
}
.box {
  background-color: #ffffff;
  padding: 32px 42px;
}
.banner, .notice {
  margin-bottom: 20px;
}
.notice {
  font-size: 16px;
  line-height: 2;
  color: #595757;
  letter-spacing: 1px
}
</style>
<template>
  <div class="home-container">
    <div class="container-fixed">
      <!--banner-->
      <div class="banner">
        <img :src="bannerUrl" alt="">
      </div>

      <!--活动规则-->
      <div class="box notice">
        <MarkdownViewer :value="activity.detail" />
      </div>

      <div class="box" ref="productListBox">
        <ProductList
          v-if="currentTopCateId"
          :secondCates="currentTopCate.children"
          :filter="filter"
          :sort="sort"
          :currentPage="currentPage"
          @change="handleListChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import MarkdownViewer from '@/components/MarkdownViewer'
import ProductList from '@/components/ProductList'
import ProductListHandler from '../mixins/ProductListHandler'

const { mapState: activityMapState } = createNamespacedHelpers('activity')
const { mapState: cateMapState, mapGetters: cateMapGetters } = createNamespacedHelpers('activityCate')

export default {
  mixins: [ProductListHandler],
  data: function () {
    return {
      bannerUrl:'',
    }
  },
  components: {
    MarkdownViewer,
    ProductList,
  },
  computed: {
    ...activityMapState([
      'activity'
    ]),
    ...cateMapState([
      'topCates',
      'currentTopCateId'
    ]),
    ...cateMapGetters([
      'currentTopCate'
    ]),
  },
  mounted() {
    this.bannerUrl = this.activity.bannerUrl
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        this.$refs.productListBox.scrollIntoView()
      })
    },
    topCates: function (newCates) {
      if (newCates.length > 0) {
        let topCateId = 0;
        const queryCateId = this.$route.query.cateId
        if (queryCateId && newCates.find(cate => queryCateId == cate.id)) {
          topCateId = queryCateId
        } else {
          topCateId = newCates[0].id
        }
        this.$store.dispatch('activityCate/setTopCateId', topCateId)
      }
    }
  }
}
</script>

